import { render, staticRenderFns } from "./stopSalary.vue?vue&type=template&id=6a0b79a9&scoped=true"
import script from "./stopSalary.vue?vue&type=script&lang=js"
export * from "./stopSalary.vue?vue&type=script&lang=js"
import style0 from "./stopSalary.vue?vue&type=style&index=0&id=6a0b79a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b79a9",
  null
  
)

export default component.exports